import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { Stack } from '@zet/design-system'
import { DEVICE_WIDTH } from '@zet/utils/Constants'

interface IProps {
  img?: string
}

export const Banner: React.FC<IProps> = ({ img }) => {
  return (
    <Stack>
      <Stack className="items-center">
        {img ? (
          <Image
            style={styles.imgStyle}
            resizeMode="contain"
            source={{ uri: img }}
          />
        ) : null}
      </Stack>
    </Stack>
  )
}

const styles = StyleSheet.create({
  imgStyle: {
    width: DEVICE_WIDTH >= 640 ? 600 : DEVICE_WIDTH * 0.92,
    aspectRatio: 1.75,
  },
})
